/* Página Black Friday da ANINA: contagem regressiva real, luz que segue o cursor
   e filtros do catálogo (universo, gênero, casa e ordenação). */
class AninaBF extends HTMLElement {
  connectedCallback() {
    this.reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.grupo = 'todos';
    this.genero = 'todos';
    this.marca = 'todas';
    this.ordem = 'padrao';
    this.grade = this.querySelector('[data-grade]');
    this.itens = this.grade ? [...this.grade.children] : [];
    this.iniciarContagem();
    this.iniciarCupom();
    this.iniciarFoco();
    this.iniciarFiltros();
    if (this.itens.length) this.aplicar(true);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    clearInterval(this.timerCupom);
    if (this.hero && this.onMove) {
      this.hero.removeEventListener('pointermove', this.onMove);
      this.hero.removeEventListener('pointerleave', this.onLeave);
    }
  }

  /* ---------- Contagem regressiva ---------- */
  iniciarContagem() {
    const box = this.querySelector('[data-contagem]');
    const ini = Date.parse(this.dataset.inicio || '');
    const fim = Date.parse(this.dataset.fim || '');
    if (!box || Number.isNaN(fim)) return;
    const rotulo = box.querySelector('[data-contagem-rotulo]');
    const nums = {};
    box.querySelectorAll('[data-u]').forEach((el) => (nums[el.dataset.u] = el));

    const tick = () => {
      const agora = Date.now();
      let alvo;
      if (!Number.isNaN(ini) && agora < ini) {
        alvo = ini;
        rotulo.textContent = 'Começa em';
      } else if (agora < fim) {
        alvo = fim;
        rotulo.textContent = 'Termina em';
      } else {
        box.hidden = true;
        clearInterval(this.timer);
        return;
      }
      box.hidden = false;
      const s = Math.max(0, Math.floor((alvo - agora) / 1000));
      const v = { dias: Math.floor(s / 86400), horas: Math.floor((s % 86400) / 3600), min: Math.floor((s % 3600) / 60), seg: s % 60 };
      for (const k in v) {
        const txt = String(v[k]).padStart(2, '0');
        const el = nums[k];
        if (el && el.textContent !== txt) {
          el.textContent = txt;
          if (!this.reduz) {
            el.classList.remove('is-tick');
            void el.offsetWidth;
            el.classList.add('is-tick');
          }
        }
      }
    };
    tick();
    this.timer = setInterval(tick, 1000);
  }

  /* ---------- Cupom da Black Friday ----------
     Antes da liberação: aviso + contagem, código oculto.
     Durante: código visível, copiar e aplicar no carrinho, contagem até o fim.
     Depois: o bloco some. O desconto em si tem as mesmas datas na Shopify,
     então o código não funciona fora do período mesmo que alguém o encontre. */
  iniciarCupom() {
    const box = this.querySelector('[data-cupom]');
    if (!box) return;
    clearInterval(this.timerCupom);
    const ini = Date.parse(box.dataset.inicio || '');
    const fim = Date.parse(box.dataset.fim || '');
    if (Number.isNaN(ini)) return;
    const titulo = box.querySelector('[data-cupom-titulo]');
    const texto = box.querySelector('[data-cupom-texto]');
    const rotulo = box.querySelector('[data-cupom-rotulo]');
    const tempo = box.querySelector('[data-cupom-tempo]');
    const itens = [...box.querySelectorAll('[data-cupom-item]')];
    let estado = '';

    const fmt = (ms) => {
      const s = Math.max(0, Math.floor(ms / 1000));
      const d = Math.floor(s / 86400);
      const h = String(Math.floor((s % 86400) / 3600)).padStart(2, '0');
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const sg = String(s % 60).padStart(2, '0');
      return d > 0 ? `${d}d ${h}h ${m}m ${sg}s` : `${h}h ${m}m ${sg}s`;
    };

    const revela = (item, i) => {
      const codigo = (item.dataset.codigo || '').trim();
      const valor = item.querySelector('[data-cupom-valor]');
      if (!valor) return;
      if (!codigo) {
        valor.textContent = 'em instantes';
        return;
      }
      valor.textContent = codigo;
      valor.removeAttribute('aria-label');
      const acoes = item.querySelector('[data-cupom-acoes]');
      if (acoes) acoes.hidden = false;
      const aplicar = item.querySelector('[data-cupom-aplicar]');
      if (aplicar) aplicar.href = `/discount/${encodeURIComponent(codigo)}?redirect=${encodeURIComponent('/cart')}`;
      if (!this.reduz) valor.animate(
        [{ opacity: 0, filter: 'blur(8px)', letterSpacing: '0.6em' }, { opacity: 1, filter: 'blur(0)', letterSpacing: '0.18em' }],
        { duration: 900, delay: i * 180, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' }
      );
    };

    const muda = (novo) => {
      if (estado === novo) return;
      estado = novo;
      box.dataset.estado = novo;
      const k = novo === 'durante' ? 'durante' : 'antes';
      if (titulo) titulo.textContent = titulo.dataset[k] || titulo.textContent;
      if (texto) texto.textContent = texto.dataset[k] || texto.textContent;
      if (novo === 'durante') itens.forEach(revela);
    };

    const tick = () => {
      const agora = Date.now();
      if (agora < ini) {
        muda('antes');
        rotulo.textContent = 'Liberados em';
        tempo.textContent = fmt(ini - agora);
      } else if (Number.isNaN(fim) || agora < fim) {
        muda('durante');
        rotulo.textContent = Number.isNaN(fim) ? 'Já liberados' : 'Válidos por mais';
        tempo.textContent = Number.isNaN(fim) ? '' : fmt(fim - agora);
      } else {
        box.hidden = true;
        clearInterval(this.timerCupom);
        return;
      }
      box.hidden = false;
    };

    if (!box.dataset.ligado) {
      box.dataset.ligado = '1';
      box.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-cupom-copiar]');
        if (!btn) return;
        const item = btn.closest('[data-cupom-item]');
        const codigo = (item?.dataset.codigo || '').trim();
        if (!codigo) return;
        try {
          await navigator.clipboard.writeText(codigo);
        } catch (_) {
          const r = document.createRange();
          r.selectNodeContents(item.querySelector('[data-cupom-valor]'));
          const sel = getSelection();
          sel.removeAllRanges();
          sel.addRange(r);
          try { document.execCommand('copy'); } catch (__) {}
        }
        btn.dataset.rotulo = btn.dataset.rotulo || btn.textContent;
        btn.textContent = 'Copiado';
        clearTimeout(btn._t);
        btn._t = setTimeout(() => (btn.textContent = btn.dataset.rotulo), 2200);
      });
    }

    tick();
    this.timerCupom = setInterval(tick, 1000);
  }

  /* ---------- Luz que segue o cursor ---------- */
  iniciarFoco() {
    this.hero = this.querySelector('.anina-bf__hero');
    if (!this.hero || this.reduz || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    let raf = 0;
    this.onMove = (e) => {
      const r = this.hero.getBoundingClientRect();
      const x = e.clientX - r.left;
      const y = e.clientY - r.top;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        this.hero.style.setProperty('--mx', `${x}px`);
        this.hero.style.setProperty('--my', `${y}px`);
        this.hero.classList.add('is-foco');
      });
    };
    this.onLeave = () => this.hero.classList.remove('is-foco');
    this.hero.addEventListener('pointermove', this.onMove, { passive: true });
    this.hero.addEventListener('pointerleave', this.onLeave);
  }

  /* ---------- Filtros ---------- */
  iniciarFiltros() {
    if (!this.grade) return;
    const contagem = { todos: this.itens.length };
    this.itens.forEach((li) => {
      const g = li.dataset.grupo;
      contagem[g] = (contagem[g] || 0) + 1;
    });
    this.querySelectorAll('[data-n]').forEach((el) => {
      const n = contagem[el.dataset.n] || 0;
      el.textContent = n;
      const aba = el.closest('[data-grupo]');
      if (!n && aba) aba.hidden = true;
    });

    this.marcasBox = this.querySelector('[data-marcas]');
    this.marcasLista = this.querySelector('[data-marcas-lista]');

    this.abas = [...this.querySelectorAll('[role="tab"][data-grupo]')];
    this.abas.forEach((aba) =>
      aba.addEventListener('click', () => {
        this.grupo = aba.dataset.grupo;
        this.marca = 'todas';
        this.abas.forEach((a) => a.setAttribute('aria-selected', String(a === aba)));
        this.aplicar();
      })
    );
    this.querySelectorAll('button[data-genero]').forEach((chip) => {
      chip.addEventListener('click', () => {
        this.genero = chip.dataset.genero;
        this.querySelectorAll('button[data-genero]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        this.aplicar();
      });
    });
    if (this.marcasLista) {
      this.marcasLista.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-marca]');
        if (!b) return;
        this.marca = b.dataset.marca;
        this.aplicar();
      });
    }
    const sel = this.querySelector('[data-ordem]');
    if (sel) sel.addEventListener('change', () => { this.ordem = sel.value; this.aplicar(); });
    const limpar = this.querySelector('[data-limpar]');
    if (limpar) limpar.addEventListener('click', () => {
      this.marca = 'todas';
      this.abas[0]?.click();
      this.querySelector('button[data-genero="todos"]')?.click();
    });
  }

  /* Chips de casa: só nas abas com várias casas (Nicho e Grifes). */
  montarMarcas() {
    if (!this.marcasBox || !this.marcasLista) return;
    const mostra = this.grupo === 'nicho' || this.grupo === 'design';
    this.marcasBox.hidden = !mostra;
    if (!mostra) return;
    const conta = new Map();
    this.itens.forEach((li) => {
      if (li.dataset.grupo !== this.grupo) return;
      if (this.genero !== 'todos' && li.dataset.genero !== this.genero) return;
      const m = li.dataset.marca;
      conta.set(m, (conta.get(m) || 0) + 1);
    });
    if (this.marca !== 'todas' && !conta.has(this.marca)) this.marca = 'todas';
    const marcas = [...conta.entries()].sort((a, b) => a[0].localeCompare(b[0], 'pt-BR'));
    const total = marcas.reduce((t, [, n]) => t + n, 0);
    const chip = (valor, rotulo, n) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'anina-bf__marca';
      b.dataset.marca = valor;
      b.setAttribute('aria-pressed', String(this.marca === valor));
      b.append(`${rotulo} `);
      const s = document.createElement('span');
      s.textContent = n;
      b.append(s);
      return b;
    };
    this.marcasLista.replaceChildren(chip('todas', 'Todas', total), ...marcas.map(([m, n]) => chip(m, m, n)));
  }

  aplicar(inicial = false) {
    this.montarMarcas();
    const rank = { nicho: 0, bond: 1, replica: 2, design: 3 };
    const n = (el, k) => Number(el.dataset[k]) || 0;
    const ordenados = [...this.itens].sort((a, b) => {
      if (this.ordem === 'menor') return n(a, 'preco') - n(b, 'preco');
      if (this.ordem === 'maior') return n(b, 'preco') - n(a, 'preco');
      if (this.ordem === 'desconto') return n(b, 'desc') - n(a, 'desc') || n(a, 'pos') - n(b, 'pos');
      return (rank[a.dataset.grupo] ?? 4) - (rank[b.dataset.grupo] ?? 4) || n(a, 'pos') - n(b, 'pos');
    });
    let visiveis = 0;
    const mostrar = [];
    ordenados.forEach((li) => {
      const ok = (this.grupo === 'todos' || li.dataset.grupo === this.grupo) &&
        (this.genero === 'todos' || li.dataset.genero === this.genero) &&
        (this.marca === 'todas' || li.dataset.marca === this.marca);
      li.hidden = !ok;
      if (ok) { visiveis++; mostrar.push(li); }
      this.grade.appendChild(li);
    });
    const cont = this.querySelector('[data-visiveis]');
    if (cont) cont.textContent = visiveis;
    const vazio = this.querySelector('[data-vazio]');
    if (vazio) vazio.hidden = visiveis > 0;
    if (inicial) return;
    if (!this.reduz && 'animate' in Element.prototype) {
      mostrar.slice(0, 12).forEach((li, i) => {
        li.animate(
          [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }],
          { duration: 460, delay: i * 45, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' }
        );
      });
    }
    const barra = this.querySelector('[data-barra]');
    if (barra && barra.getBoundingClientRect().top < 0) {
      this.querySelector('#bf-catalogo')?.scrollIntoView({ behavior: this.reduz ? 'auto' : 'smooth' });
    }
  }
}

if (!customElements.get('anina-bf')) customElements.define('anina-bf', AninaBF);
